import Common from '../Common';

export interface ContactImportBrowseColumn {
	id: id
	type: string
	label?: string
}

export interface ContactImportBrowseRow {
	id: id
	skip: "0" | "1"
	values: ContactImportBrowseRowValue[]
}

export interface ContactImportBrowseRowValue {
	id: id
	value: string
	new_value: null | string
}

export interface ContactImportJob {
	id: id
	locked: "0" | "1"
	created: string
	done: null | string
}

const defaultSearch = {
	limit: 25,
	limit_from: 0,
}

// Create a ContactsImported?

const ContactImport = class extends Common {
	create = (
		userId: id,
		body: {
			first_line_is_header: string
			contact_common: string
			delimiter: string
			enclosure: string
			escape: string
			file: Blob
		}
	) => {
		const fd = new FormData();

		fd.append('first_line_is_header', body['first_line_is_header'] ?? "0");
		fd.append('contact_common', body['contact_common'] ?? "0");
		fd.append('delimiter', body['delimiter']);
		fd.append('enclosure', body['enclosure']);
		fd.append('escape', body['escape']);
		fd.append('file', body['file']);

		return this.post(`/contactimport/${userId}/createjob`, fd);
	}

	update = (userId: id, jobId: id, body: { locked: string }) =>
		this.post(`/contactimport/${userId}/job/${jobId}/update`, body)

	browse = (userId: id, search = defaultSearch) =>
		this.get(`/contactimport/${userId}/jobs/browse`, search);

	browseColumns = (userId: id, jobId: id): CustomResponse<ContactImportBrowseColumn[]> =>
		this.get(`/contactimport/${userId}/job/${jobId}/column/browse`);

	updateColumn = (userId: id, jobId: id, columnId: id, body: { type: string | null, label: string | null }) =>
		this.post(`/contactimport/${userId}/job/${jobId}/column/${columnId}/update`, body)

	browseRows = (userId: id, jobId: id, search = defaultSearch): CustomResponseBrowse<{ rows: ContactImportBrowseRow[] }> =>
		this.get(`/contactimport/${userId}/job/${jobId}/rows/browse`, search)

	updateRow = (userId: id, jobId: id, rowId: id, body: { skip: "1" | "0" }) =>
		this.post(`/contactimport/${userId}/job/${jobId}/row/${rowId}/update`, body)

	updateRowValue = (userId: id, jobId: id, rowId: id, valueId: id, body: { new_value: string }) =>
		this.post(`/contactimport/${userId}/job/${jobId}/row/${rowId}/value/${valueId}/update`, body)

	read = (userId: id, jobId: id) =>
		this.get(`/contactimport/${userId}/job/${jobId}/read`);

	delete = (userId: id, jobId: id) =>
		this.get(`/contactimport/${userId}/job/${jobId}/delete`);
}

export default ContactImport;
